// The list selects what the table renders and sorts on, plus what Delete and the
// Price-mapping create read from a row (billingProviderId, localEntityId,
// providerEntityId). The rest lives on the detail query (§11).
export const listProviderMappings = `
    query listProviderMappings($filter: ProviderMappingsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
        listProviderMappings(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
            items {
                id
                entityType
                localEntityId
                billingProviderId
                billingProvider {
                    id
                    name
                }
                providerEntityId
                syncStatus
                lastSyncAt
                created
            }
            nextToken
        }
    }
`;

export const getProviderMapping = `
    query getProviderMapping($id: ID!) {
        getProviderMapping(id: $id) {
            id
            entityType
            localEntityId
            billingProviderId
            billingProvider {
                id
                name
                description
            }
            providerEntityId
            syncStatus
            providerSpecificData
            lastSyncAt
            syncError
            created
            updated
            createdByUsername
            createdByUser {
                username
                givenName
                familyName
            }
        }
    }
`;